import type { Theme } from "@mui/material";

/** Distância do AppBar em relação ao topo da viewport (mobile). */
export const MOBILE_HEADER_TOP_GAP = 0;

export const MOBILE_HEADER_COLLAPSED_HEIGHT = 44;
export const MOBILE_HEADER_EXPANDED_HEIGHT = 56;

export function getMobileToolbarHeight(
  isCollapsed: boolean,
  theme: Theme
): number {
  if (isCollapsed) return MOBILE_HEADER_COLLAPSED_HEIGHT;

  const toolbarMin = theme.mixins.toolbar?.minHeight;
  return typeof toolbarMin === "number" ? toolbarMin : MOBILE_HEADER_EXPANDED_HEIGHT;
}

/**
 * Offset vertical do header / conteúdo mobile.
 * @param includeSafeAreaTop — no fluxmedportable o safe-area já é nativo
 *   (`paddingTop: insets.top`); somar `env(safe-area-inset-top)` aqui gera
 *   brecha sob o AppBar (no Chrome responsivo esse env costuma ser 0).
 */
export function getMobileHeaderOffset(
  isCollapsed: boolean,
  theme: Theme,
  includeSafeAreaTop = true,
): string {
  const height = getMobileToolbarHeight(isCollapsed, theme);
  if (!includeSafeAreaTop) {
    return `${MOBILE_HEADER_TOP_GAP + height}px`;
  }
  return `calc(${MOBILE_HEADER_TOP_GAP}px + ${height}px + env(safe-area-inset-top, 0px))`;
}

export function getMobileContentTopInset(
  theme: Theme,
  includeSafeAreaTop = true,
): string {
  return getMobileHeaderOffset(false, theme, includeSafeAreaTop);
}

export const MOBILE_HEADER_PANEL_Z_INDEX_OFFSET = 45;

export const MOBILE_HEADER_ELEVATED_Z_INDEX_OFFSET = 50;

export function getMobileHeaderPanelZIndex(theme: Theme): number {
  return theme.zIndex.modal + MOBILE_HEADER_PANEL_Z_INDEX_OFFSET;
}

export function getMobileHeaderElevatedZIndex(theme: Theme): number {
  return theme.zIndex.modal + MOBILE_HEADER_ELEVATED_Z_INDEX_OFFSET;
}

export const CHAT_LUXOR_TRIGGER_Z_INDEX_OFFSET = 12;

export const CHAT_LUXOR_PANEL_Z_INDEX_OFFSET = 30;

export function getChatLuxorTriggerZIndex(theme: Theme): number {
  return theme.zIndex.modal + CHAT_LUXOR_TRIGGER_Z_INDEX_OFFSET;
}

export function getChatLuxorPanelZIndex(theme: Theme): number {
  return theme.zIndex.modal + CHAT_LUXOR_PANEL_Z_INDEX_OFFSET;
}
